import $ from "jquery";
import Cookies from "js-cookie";
import "./parsley.min.js"

$(document).ready(function () {
    function checkIfStringStartsWithVaried(str, substrs) {
        return substrs.some(substr => str.startsWith(substr));
    }

    if ($('.floating-form').length)
        setupFloatingForm();

    if ($('#include-address-format-validation').length > 0) {
        // this ID is added to a hidden form field when the corresponding option is selected in the CMS widget
        // add conditional window.Parsley.addValidator('validateStreetAddress',...
        // this option is not being used currently as all forms need address validation (added below for all)
    }

    window.Parsley.addValidator('validateStreetAddress', {
        validateString: function (value) {
            const streetInfo = value.split(' ');
            if (streetInfo.length < 2) return;

            let [number, street] = streetInfo;
            number = number.replace('#', '');

            return (!isNaN(number)) && isNaN(street);
        },
        messages: {
            en: 'Oops! Please include a house number before the street name.'
        }
    });

    window.Parsley.addValidator('validatePhoneNumber', {
        validateString: function (value) {
            const phone = value.replace(/\D/g, '');
            const tollfrees = ['1800', '1888', '1855', '1866', '1877', '800', '888', '855', '866', '877'];
            let isToll = checkIfStringStartsWithVaried(phone, tollfrees);
            return !isToll;
        },
        messages: {
            en: 'Oops! Phone number cannot be toll-free or international.'
        }
    });

    setupMovingLabels();
    setupMaskedInput($);
    populateForms();
    handleLeadForms();

    // ensure google maps api is loaded
    // initAddrAutosuggest defined in shared.js
    if ($('form.autosuggest').length) {
        $('form.autosuggest #street_address').on('focus', function () {
            if ($('script[src*="maps.googleapis.com"]').length == 0) {
                $('<script src="https://maps.googleapis.com/maps/api/js?key=' + window.wbuh.mapKey + '&libraries=places&callback=initAddrAutosuggest"></script>').appendTo('head');
            }
        }).on('keypress', function (e) {
            if (e.which == 13) {
                // do not submit form when user is selecting autosuggest address
                e.preventDefault();
            }
        });
    }
});

function setupFloatingForm() {
    $('#page').addClass('with-floating-form');

    $(window).on('resize', function () {
        let hero = $('.hero');
        if (hero.length) {
            if (Foundation.mediaQuery.MediaQuery.atLeast('xlarge')) {
                let heroHeight = hero.height();
                $('.floating-form').css('top', '-' + heroHeight + 'px');
            } else {
                $('.floating-form').css('top', '');
            }
        }
    }).trigger('resize');
}

function setupMovingLabels() {
    $(".lead-form input").on("blur", function () {
        if ($(this).val() !== "") {
            $(this).parent().addClass("has-content");
        } else {
            $(this).parent().removeClass("has-content");
        }
    });

    $(".lead-form select").on("change", function () {
        if ($(this).val() !== "") {
            $(this).parent().addClass("has-content");
        } else {
            $(this).parent().removeClass("has-content");
        }
    });

    $('.lead-form select').on('change', function () {
        var $label = $(this).parent().find('label');
        if ($(this).val() != '' && $label.hasClass('select-label')) {
            $label.addClass('show-for-sr');
        }
    });

    // move labels if browser has pre-filled inputs
    window.addEventListener("pageshow", () => {
        $(".lead-form :input").each(function () {
            if ($(this).val() !== "") {
                $(this).parent().addClass("has-content");
            }
        });
    });
}

function populateForms() {

    var altTitles = false;
    if (localStorage.getItem("street_address") !== null && localStorage.getItem("street_address") != "") {
        $('#street_address').val(localStorage.getItem("street_address")).siblings('label').addClass('out active has-value').parent().addClass('has-content');
        altTitles = true;
    }
    if (localStorage.getItem("city") !== null && localStorage.getItem("city") != "") {
        $('#lf-city').val(localStorage.getItem("city")).siblings('label').addClass('out active has-value').parent().addClass('has-content');
        altTitles = true;
    }
    if (localStorage.getItem("state") !== null && localStorage.getItem("state") != "") {
        //$('#lf-state').val(localStorage.getItem("state")).closest('li').find('label').addClass('out active');
        $('#lf-state').val(localStorage.getItem("state")).siblings('label').addClass('out active has-value').parent().addClass('has-content');
        altTitles = true;
    }
    if (localStorage.getItem("zip") !== null && localStorage.getItem("zip") != "") {
        $('#lf-zip').val(localStorage.getItem("zip")).siblings('label').addClass('out active has-value').parent().addClass('has-content');
        altTitles = true;
    }
}

function handleLeadForms() {
    $("#phone").mask("(999) 999-9999");

    $('#street_address, #lf-city, #lf-state, #lf-zip, #first_name, #last_name, #phone, #email').on("keyup blur", function () {
        // custom error resets
        var thisFieldInstance = $(this).parsley();
        thisFieldInstance.reset();
        thisFieldInstance.validate();

        toggleSubmitButton($(this).closest('form'));
    });

    /*$('[data-parsley-validate]').parsley();
    $('[data-parsley-validate]').on('field:validated', function () {
        var ok = $('.parsley-error').length === 0;
        $('.bs-callout-info').toggleClass('hidden', !ok);
        $('.bs-callout-warning').toggleClass('hidden', ok);
    });*/
    $('[data-parsley-validate]').parsley().on('form:validated', function () {
        var form = $(this.element);
        var errors = form.find('.parsley-error');
        if (errors.length > 0) {
            form.find('.global-form-callout-warning').fadeIn('fast');
            var ticker = setInterval(function () {
                errors = form.find('.parsley-error');
                if (errors.length == 0) {
                    form.find('.global-form-callout-warning').fadeOut('fast');
                    clearInterval(ticker);
                }
            }, 500);
        }
    });

    $('p.privacy-disclaimer a').click(function (event) {
        event.preventDefault();
        $('#btn-privacy-policy').click();
    });

    $('.lead-form').submit(function (e) {
        e.preventDefault();

        var lead = new Object();

        // mark as test lead if coming from dev or staging site
        if (window.location.host.indexOf('dev.') != -1 || window.location.host.indexOf('stage.') != -1 || window.location.host.indexOf('localhost:') != -1) {
            lead.testLead = true;
        }

        /* Key for HomeVestors.com web form */
        lead.APIKey = '1321217';
        lead.AppID = '39';
        lead.origin = window.location.host.replace('www.', '');

        //VWO testing form name
        lead.mkt_form_type = $("#mkt_form_type, [name='mkt_form_type']", this).val();

        lead.firstName = $("#first_name, [name='first-name']", this).val();
        lead.lastName = $("#last_name, [name='last-name']", this).val();
        lead.phoneNumber = $("#phone, [name='phone']", this).val();
        lead.email = $("#email, [name='email']", this).val();
        lead.address = $("#street_address, [name='street-address']", this).val();
        lead.city = $("#lf-city, [name='city']", this).val();
        lead.state = $("#lf-state, [name='state']", this).val();
        lead.zip = $("#lf-zip, [name='zip']", this).val();
        lead.sms_opt_in = $("#sms_opt_in", this).is(":checked");
        lead.session_id = localStorage.getItem('session-id');
        lead.user_id = localStorage.getItem('user-id');

        lead.mkt_medium = getMarketingInfo('utm_medium');
        lead.mkt_source = getMarketingInfo('utm_source');
        lead.mkt_campaign = getMarketingInfo('utm_campaign');
        lead.mkt_content = getMarketingInfo('utm_content');

        let click_id = '';
        if (getMarketingInfo('ttdclid') != '')
            click_id = getMarketingInfo('ttdclid');
        else if (getMarketingInfo('msclid') != '')
            click_id = getMarketingInfo('msclid');
        else if (getMarketingInfo('gclid') != '')
            click_id = getMarketingInfo('gclid');
        else if (getMarketingInfo('msclkid') != '')
            click_id = getMarketingInfo('msclkid');
        else if (getMarketingInfo('fbclid') != '')
            click_id = getMarketingInfo('fbclid');


        lead.mkt_clickid = click_id;
        lead.mkt_term = getMarketingInfo('utm_term');
        lead.refr_url = document.referrer;
        lead.ip_address = window.clientIPAddress;

        var goodList = ['google-search', 'bing', 'gemini', 'google-display', 'facebook', 'adscience', 'google_search', 'google_display', 'affiliate', 'youtube', 'directmail'];
        if (goodList.indexOf(getMarketingInfo('utm_source')) >= 0)
            lead.leadSource = 'Paid';
        else
            lead.leadSource = 'Organic';

        // Performance Max can send us a gclid without utm_source. Mark it as Paid
        if (getMarketingInfo('gclid') != '')
            lead.leadSource = 'Paid';

        lead.id = '1';
        lead.url = window.location.href;
        lead.meta = {};

        if ($('[name="house_Condition_Scale"]:checked', this).length) {
            lead.meta.house_condition_scale = $('[name="house_Condition_Scale"]:checked', this).val();
            //lead.persona = 'ibuyer';
            lead.APIKey = '1234235';
            lead.AppID = '14';

            //Cookies.set('homeVestimate', '1'); // display special success page
        }
        //if ($('[name="contact_preference"]:checked').length)
        //    lead.contact_preference = $('[name="contact_preference"]:checked').val();

        if ($('#contact-recaptcha', this).length > 0) {
            const response = grecaptcha.getResponse();
            if (!response) {
                displayError("Oh, no. Something went wrong. Please click the box below.");
                return;
            }
        }

        if ($('#include-zip-state-validation, [data-validate-zip-state]', this).length > 0) {
            // this ID is added to a hidden form field when the corresponding option is selected in the CMS widget
            // validate zipcode depending of the selected state
            var zipFieldInstance = $('#lf-zip').parsley();

            $.get(`/FormValidations/ValidateZipCode/?state=${lead.state}&zipCode=${lead.zip}`, (result) => {
                zipFieldInstance.removeError('zipStateError'); // always clear error first to avoid stacking

                if (result) {
                    sendLeadToArch(lead);
                } else {
                    zipFieldInstance.addError('zipStateError', { message: "Oops! ZIP code doesn't match state." });
                    $('[data-parsley-validate]').parsley().trigger('form:validated');
                }
            });
        } else {
            sendLeadToArch(lead);
        }
    });

    toggleSubmitButton();
}

function toggleSubmitButton(form) {
    form = form || $('[data-parsley-validate]');
    var submitButton = form.find('input[type="submit"], button[type="submit"]');
    var isValid = form.parsley().isValid({ view: 'none' }); // front end validation
    var errors = form.find('.parsley-error'); // check if user changed field w/ server side error

    if (errors.length > 0) {
        isValid = false;
    }

    if (isValid) {
        submitButton.removeClass('button-disabled');
    } else {
        submitButton.addClass('button-disabled');
    }
}

function sendLeadToArch(lead) {
    var apiUrl = 'https://arch-form.advestors.net/v2';

    $.ajax({
        url: apiUrl + '/leads/create',
        type: 'POST',
        crossDomain: true,
        contentType: "application/json",

        data: JSON.stringify(lead),

        beforeSend: function (data) {
            data.setRequestHeader('Authorization', make_base_auth(lead.APIKey, lead.AppID));
            $('#loader-wrap').fadeIn();
        },

        error: function (data, textStatus, errorThrown) {
            console.log("Error");
            console.log(textStatus);
            $('#loader-wrap').hide();
            var msg = 'Failed to submit to API';
            displayError(msg);
        },

        success: function (data, textStatus, xhr) {

            if (data.success) {
                console.log("We got the success object! Parsing success message...");

                switch (data.success_message) {
                    case "0":
                        console.log("Not assigned because no active agent found in territory");
                        window.location = "/outofarea/";
                        break;

                    case "1":
                        console.log("Lead Rotation");
                        console.log("Redirecting to Success Page...");
                        Cookies.set('allowSuccess', '1');
                        if (getMarketingInfo('utm_campaign') == 'leadgentest')
                            notifyFluent();
                        window.location = "/success/";
                        break;

                    case "2":
                        console.log("Sticky");
                        window.location = "/dupe/";
                        break;

                    case "3":
                        console.log("Out of area rotation");
                        window.location = "/outofarea/";
                        break;

                    case "999":
                        console.log("Same-session dupe");
                        Cookies.set('allowSuccess', '1'); // will get redirected to success page, so need to allow success
                        window.location = "/dupe/";
                        break;

                    default:
                        console.log("Unknown success message: " + data.success_message);
                        $('#loader-wrap').hide();
                        var msg = 'Unknown response';
                        displayError(msg);
                }
            }
            else {
                console.log("We did not get a successful response... Parsing error messages..");

                var msg = 'Unknown error';
                for (var k in data.errors) {
                    for (var i = 0; i < data.errors[k].length; i++) {
                        msg = data.errors[k][i];
                        console.log(msg);
                    }

                    // field level errors based on server response
                    var thisFieldInstance;
                    if (k === "phoneNumber") {
                        thisFieldInstance = $('#phone').parsley();
                        thisFieldInstance.reset(); // always clear error first to avoid stacking
                    }
                    else if (k === "firstName") {
                        thisFieldInstance = $('#first_name').parsley();
                        thisFieldInstance.reset();
                    }
                    else if (k === "lastName") {
                        thisFieldInstance = $('#last_name').parsley();
                        thisFieldInstance.reset();
                    }
                    else if (k === "email") {
                        thisFieldInstance = $('#email').parsley();
                        thisFieldInstance.reset();
                    }
                    else if (k === "address") {
                        thisFieldInstance = $('#street_address').parsley();
                        thisFieldInstance.reset();
                    }
                    else if (k === "city") {
                        thisFieldInstance = $('#lf-city').parsley();
                        thisFieldInstance.reset();
                    }

                    if (/cannot contain test/i.test(msg)) {
                        thisFieldInstance.addError('containsTestError', { message: "Oops! Field cannot contain the word &quot;Test&quot;." });
                        msg = "";
                    }
                    else if (/bad language/i.test(msg)) {
                        thisFieldInstance.addError('profanityError', { message: "Field cannot contain ugly language. Please adjust your entry or call us." });
                        msg = "";
                    }
                    else if (/phone number/i.test(msg)) {
                        thisFieldInstance.addError('phoneNumberError', { message: "Oops! Area code cannot start with 1." });
                        msg = "";
                    }
                }

                $('#loader-wrap').hide();
                displayError(msg);
                $('[data-parsley-validate]').parsley().trigger('form:validated');
                toggleSubmitButton();
            }

        }

    });
}


function notifyFluent() {
    var fluentUrl = 'https://f.prformce.com/aff_lsr?offer_id=10875&transaction_id=' + getMarketingInfo('utm_term');

    $.ajax({
        url: fluentUrl,
        async: false
    }); // don't care about the result, but async makes sure the request complete
}

function make_base_auth(APIKey, RefID) {
    var tok = btoa(APIKey) + ':' + btoa(RefID);
    return "Basic " + tok;
}

function removeError() {
    $('.lead-form .alert').remove();
}

function displayError(msg, displayError = false) {
    $('.lead-form .alert').remove();

    if (msg !== "") {
        // only display contact lead form error if not empty
        $('#lead-submit').parent().prepend(`<span class="alert"><strong>${displayError ? 'Error: ' : ''}${msg}</strong></span>`);
    }
    else {
        // if empty, set default error message for vertical form
        msg = "Please correct the error(s) above";
    }

    $('#lead-vertical-form .global-form-callout-warning p').text(`${displayError ? 'Error: ' : ''}${msg}`).fadeIn('fast');
    $('#lead-vertical-form .global-form-callout-warning').fadeIn('fast');
}
function getMarketingInfo(key) {
    let retval = getUrlParameter(key);
    if (retval == '')
        retval = Cookies.get(key);
    if (retval == undefined)
        return ''; // normalize no result to empty string

    return retval;
}

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);

    return (results === null || results === undefined) ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function setupMaskedInput($jq) {
    /*
    Masked Input plugin for jQuery
    Copyright (c) 2007-2011 Josh Bush (digitalbush.com)
    Licensed under the MIT license (http://digitalbush.com/projects/masked-input-plugin/#license)
    Version: 1.3
    https://cloud.github.com/downloads/digitalBush/jquery.maskedinput/jquery.maskedinput-1.3.min.js
    */
    (function (jQuery, window, undefined) {
        "use strict";

        var matched, browser;

        jQuery.uaMatch = function (ua) {
            ua = ua.toLowerCase();

            var match = /(opr)[\/]([\w.]+)/.exec(ua) ||
                /(chrome)[ \/]([\w.]+)/.exec(ua) ||
                /(version)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(ua) ||
                /(webkit)[ \/]([\w.]+)/.exec(ua) ||
                /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
                /(msie) ([\w.]+)/.exec(ua) ||
                ua.indexOf("trident") >= 0 && /(rv)(?::| )([\w.]+)/.exec(ua) ||
                ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) ||
                [];

            var platform_match = /(ipad)/.exec(ua) ||
                /(iphone)/.exec(ua) ||
                /(android)/.exec(ua) ||
                /(windows phone)/.exec(ua) ||
                /(win)/.exec(ua) ||
                /(mac)/.exec(ua) ||
                /(linux)/.exec(ua) ||
                /(cros)/i.exec(ua) ||
                [];

            return {
                browser: match[3] || match[1] || "",
                version: match[2] || "0",
                platform: platform_match[0] || ""
            };
        };

        matched = jQuery.uaMatch(window.navigator.userAgent);
        browser = {};

        if (matched.browser) {
            browser[matched.browser] = true;
            browser.version = matched.version;
            browser.versionNumber = parseInt(matched.version);
        }

        if (matched.platform) {
            browser[matched.platform] = true;
        }

        // These are all considered mobile platforms, meaning they run a mobile browser
        if (browser.android || browser.ipad || browser.iphone || browser["windows phone"]) {
            browser.mobile = true;
        }

        // These are all considered desktop platforms, meaning they run a desktop browser
        if (browser.cros || browser.mac || browser.linux || browser.win) {
            browser.desktop = true;
        }

        // Chrome, Opera 15+ and Safari are webkit based browsers
        if (browser.chrome || browser.opr || browser.safari) {
            browser.webkit = true;
        }

        // IE11 has a new token so we will assign it msie to avoid breaking changes
        if (browser.rv) {
            var ie = "msie";

            matched.browser = ie;
            browser[ie] = true;
        }

        // Opera 15+ are identified as opr
        if (browser.opr) {
            var opera = "opera";

            matched.browser = opera;
            browser[opera] = true;
        }

        // Stock Android browsers are marked as Safari on Android.
        if (browser.safari && browser.android) {
            var android = "android";

            matched.browser = android;
            browser[android] = true;
        }

        // Assign the name and platform variable
        browser.name = matched.browser;
        browser.platform = matched.platform;


        jQuery.browser = browser;
    })($jq, window);
    (function (a) { var b = (a.browser.msie ? "paste" : "input") + ".mask", c = window.orientation != undefined; a.mask = { definitions: { 9: "[0-9]", a: "[A-Za-z]", "*": "[A-Za-z0-9]" }, dataName: "rawMaskFn" }, a.fn.extend({ caret: function (a, b) { if (this.length != 0) { if (typeof a == "number") { b = typeof b == "number" ? b : a; return this.each(function () { if (this.setSelectionRange) this.setSelectionRange(a, b); else if (this.createTextRange) { var c = this.createTextRange(); c.collapse(!0), c.moveEnd("character", b), c.moveStart("character", a), c.select() } }) } if (this[0].setSelectionRange) a = this[0].selectionStart, b = this[0].selectionEnd; else if (document.selection && document.selection.createRange) { var c = document.selection.createRange(); a = 0 - c.duplicate().moveStart("character", -1e5), b = a + c.text.length } return { begin: a, end: b } } }, unmask: function () { return this.trigger("unmask") }, mask: function (d, e) { if (!d && this.length > 0) { var f = a(this[0]); return f.data(a.mask.dataName)() } e = a.extend({ placeholder: "_", completed: null }, e); var g = a.mask.definitions, h = [], i = d.length, j = null, k = d.length; a.each(d.split(""), function (a, b) { b == "?" ? (k--, i = a) : g[b] ? (h.push(new RegExp(g[b])), j == null && (j = h.length - 1)) : h.push(null) }); return this.trigger("unmask").each(function () { function v(a) { var b = f.val(), c = -1; for (var d = 0, g = 0; d < k; d++)if (h[d]) { l[d] = e.placeholder; while (g++ < b.length) { var m = b.charAt(g - 1); if (h[d].test(m)) { l[d] = m, c = d; break } } if (g > b.length) break } else l[d] == b.charAt(g) && d != i && (g++, c = d); if (!a && c + 1 < i) f.val(""), t(0, k); else if (a || c + 1 >= i) u(), a || f.val(f.val().substring(0, c + 1)); return i ? d : j } function u() { return f.val(l.join("")).val() } function t(a, b) { for (var c = a; c < b && c < k; c++)h[c] && (l[c] = e.placeholder) } function s(a) { var b = a.which, c = f.caret(); if (a.ctrlKey || a.altKey || a.metaKey || b < 32) return !0; if (b) { c.end - c.begin != 0 && (t(c.begin, c.end), p(c.begin, c.end - 1)); var d = n(c.begin - 1); if (d < k) { var g = String.fromCharCode(b); if (h[d].test(g)) { q(d), l[d] = g, u(); var i = n(d); f.caret(i), e.completed && i >= k && e.completed.call(f) } } return !1 } } function r(a) { var b = a.which; if (b == 8 || b == 46 || c && b == 127) { var d = f.caret(), e = d.begin, g = d.end; g - e == 0 && (e = b != 46 ? o(e) : g = n(e - 1), g = b == 46 ? n(g) : g), t(e, g), p(e, g - 1); return !1 } if (b == 27) { f.val(m), f.caret(0, v()); return !1 } } function q(a) { for (var b = a, c = e.placeholder; b < k; b++)if (h[b]) { var d = n(b), f = l[b]; l[b] = c; if (d < k && h[d].test(f)) c = f; else break } } function p(a, b) { if (!(a < 0)) { for (var c = a, d = n(b); c < k; c++)if (h[c]) { if (d < k && h[c].test(l[d])) l[c] = l[d], l[d] = e.placeholder; else break; d = n(d) } u(), f.caret(Math.max(j, a)) } } function o(a) { while (--a >= 0 && !h[a]); return a } function n(a) { while (++a <= k && !h[a]); return a } var f = a(this), l = a.map(d.split(""), function (a, b) { if (a != "?") return g[a] ? e.placeholder : a }), m = f.val(); f.data(a.mask.dataName, function () { return a.map(l, function (a, b) { return h[b] && a != e.placeholder ? a : null }).join("") }), f.attr("readonly") || f.one("unmask", function () { f.unbind(".mask").removeData(a.mask.dataName) }).bind("focus.mask", function () { m = f.val(); var b = v(); u(); var c = function () { b == d.length ? f.caret(0, b) : f.caret(b) }; (a.browser.msie ? c : function () { setTimeout(c, 0) })() }).bind("blur.mask", function () { v(), f.val() != m && f.change() }).bind("keydown.mask", r).bind("keypress.mask", s).bind(b, function () { setTimeout(function () { f.caret(v(!0)) }, 0) }), v() }) } }) })($jq);
}

// called from shared.js
window.setupLeadFormAutoSuggest = function () {
    var suggestOptions = {
        componentRestrictions: { country: "US" },
        fields: ["address_components"]
    };

    $('.lead-form.autosuggest').each(function () {
        if ($('#street_address', this).attr('placeholder') == undefined)
            $('#street_address', this).attr('placeholder', '');

        var input = $('#street_address', this).get(0);
        var autocomplete = new google.maps.places.Autocomplete(input, suggestOptions);


        autocomplete.addListener('place_changed', function () {

            var place = autocomplete.getPlace();

            var stnum, stname, city, state, zipcode;

            for (var i = 0; i < place.address_components.length; i++) {

                for (var j = 0; j < place.address_components[i].types.length; j++) {

                    if (place.address_components[i].types[j] == "street_number")
                        stnum = place.address_components[i]['short_name'];

                    if (place.address_components[i].types[j] == "route")
                        stname = place.address_components[i]['short_name'];

                    if (place.address_components[i].types[j] == "locality")
                        city = place.address_components[i]['short_name'];

                    if (place.address_components[i].types[j] == "administrative_area_level_1")
                        state = place.address_components[i]['short_name'];

                    if (place.address_components[i].types[j] == "postal_code")
                        zipcode = place.address_components[i]['short_name'];

                }

            }

            // if the ZIP code has been pre-set, don't allow autosuggest to change it
            // Google does not have any addresses in 75072, so this breaks for those addresses.
            // We are therefore disabling this, and also not changing the zip from the autosuggest
            //if ($('#lf-zip').prop('readonly')) {
            //    if (zipcode != $('#lf-zip').val()) {
            //        alert('The selected address is not in ' + $('#lf-zip').val() + '. Please select another address.');
            //        $('#street_address').val('');
            //        return;
            //    }
            //}

            var street = "";
            if (typeof (stnum) !== 'undefined') street += stnum + " ";
            if (typeof (stname) !== 'undefined') street += stname;

            $('#street_address').val(street);
            $('#lf-city').val(city).trigger('focus').trigger('blur').nextAll('label').addClass('active').parent().addClass('has-content');
            $('#lf-state').val(state).trigger('focus').trigger('blur').nextAll('label').addClass('active').parent().addClass('has-content');
            $('.select-label').addClass('show-for-sr');
            if (!$('#lf-zip').prop('readonly')) {
                $('#lf-zip').val(zipcode).trigger('focus').trigger('blur').nextAll('label').addClass('active').parent().addClass('has-content');
            }

        });

        // wait for Google Places to set the autocomplete value, then change it
        setTimeout(function () {
            $('#street_address').attr('autocomplete', 'dont-complete');
        }, 1000);
    });
};
